export default {
  title: 'Kasse',
};
